/* eslint-disable @typescript-eslint/no-explicit-any */
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from '../apiClient';
import type { ILead, Status } from '../types/lead';
import type { IRequestException } from '../types/requestException';

interface IUpdateStatusProps {
    ids: any;
    newStatus: Status;
}

export const updateLeadStatuses = async ({
    ids,
    newStatus,
}: IUpdateStatusProps) => {
    await apiClient.patch(`property-leads`, {
        json: {
            ids,
            status: newStatus,
        },
    });

    return {} as ILead;
};

export const useUpdateStatusesMutation = (
    options: UseMutationOptions<ILead, IRequestException, IUpdateStatusProps>
) => {
    return useMutation<ILead, IRequestException, IUpdateStatusProps>(
        async (props) => await updateLeadStatuses(props),
        {
            ...options,
        }
    );
};
